module.exports = __webpack_public_path__ + "img/btn_fixed.92aaa9aa.png";